import {Injectable} from 'ng-metadata/core';

@Injectable()
export class BlankIllService {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/blankIll/blankIll.service.ts